import { Workbox } from "workbox-window"

export function registerServiceWorker(): void {
  if (typeof window === "undefined") return
  if (!("serviceWorker" in navigator)) return
  if (import.meta.env.DEV) return

  const wb = new Workbox("/sw.js")

  wb.addEventListener("waiting", () => {
    /* New SW is waiting. A future enhancement can prompt the user;
     * for now, take control automatically. */
    wb.messageSkipWaiting()
  })

  wb.addEventListener("controlling", () => {
    window.location.reload()
  })

  wb.register().catch((error) => {
     
    console.error("Service worker registration failed:", error)
  })
}
